import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { ChannelParamDef } from './agentFormTypes';

export interface ChannelParamInputProps {
  def: ChannelParamDef;
  value: string;
  onChange: (val: string) => void;
}

export default function ChannelParamInput({ def, value, onChange }: ChannelParamInputProps) {
  const isBoolean = def.type === 'boolean' || def.type === 'bool';
  const isArray = def.type === 'array' || def.type.endsWith('[]');

  if (def.options && def.options.length > 0) {
    return (
      <div className="space-y-1.5">
        <Label className="text-sm font-medium">{def.label}</Label>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
        >
          {def.options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  if (isBoolean) {
    return (
      <div className="flex items-center justify-between py-1">
        <Label className="text-sm font-medium">{def.label}</Label>
        <input
          type="checkbox"
          checked={value === 'true'}
          onChange={(e) => onChange(e.target.checked ? 'true' : 'false')}
          className="h-4 w-4 rounded border-border text-primary focus:ring-primary"
        />
      </div>
    );
  }

  if (isArray) {
    const items = (() => {
      const src = (value || '[]').trim();
      if (!src || src === '[]') return '';
      try {
        const arr = JSON.parse(src);
        if (Array.isArray(arr)) return arr.map(String).join('\n');
      } catch {
        // fallback
      }
      return src
        .split(/[\n,]/)
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0)
        .join('\n');
    })();
    return (
      <div className="space-y-1.5">
        <Label className="text-sm font-medium">{def.label}</Label>
        <textarea
          value={items}
          onChange={(e) => {
            const vals = e.target.value
              .split('\n')
              .map((s) => s.trim())
              .filter((s) => s.length > 0);
            onChange(JSON.stringify(vals));
          }}
          rows={2}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring resize-none"
          placeholder="每行一个值"
        />
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      <Label className="text-sm font-medium">{def.label}</Label>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 text-sm"
        placeholder={def.label}
      />
    </div>
  );
}
